import { content, client } from '@/api';
import dataEngine from '@/lib/engine';

import * as types from '../../mutationTypes';

export default {
  async getAll({ commit, dispatch, rootGetters }, updateModuleId) {
    const type = 'all';

    const isAdminDraftView = rootGetters['authorisation/isAdminDraftView'];

    const getActivatedCEModulesPromise = content.getActivatedCEModules(type);
    const getChildActivatedModulesPromise = client.getChildActivatedModules();

    const response = await Promise.all([
      getActivatedCEModulesPromise,
      getChildActivatedModulesPromise
    ]);

    const getActivatedCEModules = response[0].data;
    const getChildActivatedModules = response[1].data;

    // add childActivated property into each module object
    const activatedCEModulesWithChildActivated = getActivatedCEModules.map((ceModule) => ({
      ...ceModule,
      childActivated: getChildActivatedModules.includes(ceModule.id)
    }));

    if (updateModuleId) {
      dispatch(
        'data/updateSingleModule',
        activatedCEModulesWithChildActivated.find((ele) => ele.id === updateModuleId),
        { root: true }
      );
      commit(types.DATA_SET_TOC_STATE, dataEngine.MANAGER_STATE.STATE_UPDATING, { root: true });
    } else {
      dispatch('data/updateModules', activatedCEModulesWithChildActivated, { root: true });
    }

    const activatedCEModules = isAdminDraftView
      ? activatedCEModulesWithChildActivated
      : activatedCEModulesWithChildActivated.filter((module) => module.hasPublishedContents);

    commit(types.BULK_ADD_ACTIVATED_CEMODULES, activatedCEModules);
  }
};
